module.exports = __webpack_public_path__ + "static/who-we-help-operator-4eaf505ba0f63285371bb48e95763775.jpg";